import { useClickstreamAnalytics, ITrackType } from '../clickstream-analytics-context';
export var useEgClickstream = function () {
    var track = useClickstreamAnalytics().track;
    return function (data) {
        track(ITrackType.EVENT, {
            data: data,
            config: { isEgClickstream: true }
        });
    };
};
//# sourceMappingURL=use-eg-clickstream.js.map